import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../firebase'; 
import { doc, getDoc, collection, query, where, getDocs } from 'firebase/firestore';
// ✅ Added 'Users' icon for Subscriptions
import { Bell, User, Users } from 'lucide-react'; 

// ✅ Added sharedCount to props so Topbar knows how many alerts you have!
export default function Topbar({ setOpen, sharedCount = 0 }) {
  const navigate = useNavigate();
  const [userPersona, setUserPersona] = useState(null);
  
  const [subscribedCreators, setSubscribedCreators] = useState([]);
  const [showSubModal, setShowSubModal] = useState(false);
  const [loadingSubs, setLoadingSubs] = useState(false);

  useEffect(() => {
    const fetchPersona = async () => {
      const user = auth.currentUser;
      if (user) {
        try {
          const docRef = doc(db, 'profiles', user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            setUserPersona(docSnap.data().persona);
          }
        } catch (error) {
          console.error("Error fetching persona:", error);
        }
      }
    };
    fetchPersona();
  }, []);

  const fetchMySubscriptions = async () => {
    const user = auth.currentUser;
    if (!user) return;

    setLoadingSubs(true);
    try {
      const q = query(collection(db, "subscriptions"), where("subscriberId", "==", user.uid));
      const subSnap = await getDocs(q);
      const creatorIds = subSnap.docs.map(doc => doc.data().creatorId);

      if (creatorIds.length === 0) {
        setSubscribedCreators([]);
      } else {
        let profiles = [];
        for (let i = 0; i < creatorIds.length; i += 10) {
          const chunk = creatorIds.slice(i, i + 10);
          const pQuery = query(collection(db, "public_profiles"), where("__name__", "in", chunk));
          const pSnap = await getDocs(pQuery);
          profiles = [...profiles, ...pSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }))];
        }
        setSubscribedCreators(profiles);
      }
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
    } finally {
      setLoadingSubs(false);
    }
  };

  useEffect(() => {
    if (showSubModal) fetchMySubscriptions();
  }, [showSubModal]);

  const handleNavigation = (path) => {
    navigate(path);
    setShowSubModal(false);
  };
  
  return (
    <header className="bg-white border-b border-gray-200 shadow-sm w-full">
      
      <div className="flex items-center px-2 py-2">

{/* Burger Menu */}
        <button
          className="lg:hidden text-gray-700 text-2xl p-1 mr-1 shrink-0"
          onClick={() => setOpen(prev => !prev)} 
        >
          ☰
        </button>

        {/* ✅ SCROLLABLE BUTTON CONTAINER */}
        <div className="flex-1 overflow-x-auto pb-1">
          <div className="flex items-center justify-start lg:justify-end gap-2 min-w-max px-1">

            {/* 4. ADD LESSON */}
            <button
              onClick={() => handleNavigation('/VoicetoText')}
              className="flex items-center gap-1.5 px-2.5 py-1.5 lg:px-3 lg:py-2 rounded-lg hover:bg-gray-50 transition border border-gray-200"
            >
              <img src="/Add_Lesson.png" className="w-4 h-4" alt="Add" />
              <span className="text-xs lg:text-sm font-medium text-gray-800">Add Lesson</span>
            </button>

            {/* 5. ADD WORKSHEET (Teacher Only) */}
            
              <button
                onClick={() => handleNavigation('/AddWorksheet')}
                className="flex items-center gap-1.5 px-2.5 py-1.5 lg:px-3 lg:py-2 rounded-lg hover:bg-gray-50 transition border border-gray-200"
              >
                <img src="/Parent_Worksheet.png" className="w-4 h-4" alt="Worksheet" />
                <span className="text-xs lg:text-sm font-medium text-gray-800">Add Worksheet</span>
              </button>
            

            {/* 1. MY ALERTS (Moved from Hero) */}
            <button
              onClick={() => handleNavigation('/Alert_Summary')}
              className="relative flex items-center gap-1.5 px-2.5 py-1.5 lg:px-3 lg:py-2 rounded-lg bg-red-50 hover:bg-red-100 text-red-700 transition border border-red-100"
            >
              <Bell className="w-4 h-4" />
              <span className="text-xs lg:text-sm font-bold">Alerts</span>
              {sharedCount > 0 && (
                <div className="absolute -top-0 -right-1.5 bg-red-500 text-white text-[9px] font-bold w-4 h-4 flex items-center justify-center rounded-full shadow-sm animate-pulse">
                  {sharedCount}
                </div>
              )}
            </button>

            {/* 2. MY SUBSCRIPTIONS (Now uses 'Users' icon) */}
            <button
              onClick={() => setShowSubModal(true)}
              className="flex items-center gap-1.5 px-2.5 py-1.5 lg:px-3 lg:py-2 rounded-lg bg-purple-50 hover:bg-purple-100 text-purple-700 transition border border-purple-100"
            >
              <Users className="w-4 h-4" />
              <span className="text-xs lg:text-sm font-bold">Subscriptions</span>
            </button>

            {/* 3. MY STOREFRONT */}
            <button
              onClick={() => {
                if (auth.currentUser) {
                  handleNavigation(`/CreatorProfile/${auth.currentUser.uid}`);
                }
              }}
              className="flex items-center gap-1.5 px-2.5 py-1.5 lg:px-3 lg:py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white transition shadow-sm"
            >
              <User className="w-4 h-4" />
              <span className="text-xs lg:text-sm font-bold">Storefront</span>
            </button>

{/*
            <button
              onClick={() => {
                if (auth.currentUser) {
                  handleNavigation(`/DragDropPalette`);
                }
              }}
              className="flex items-center gap-1.5 px-2.5 py-1.5 lg:px-3 lg:py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white transition shadow-sm"
            >
              <User className="w-4 h-4" />
              <span className="text-xs lg:text-sm font-bold">Molecule Builder</span>
            </button>
*/}


          </div>
        </div>
      </div>

      {/* --- SUBSCRIPTION MODAL --- */}
      {showSubModal && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-2xl overflow-hidden">
            <div className="p-4 border-b flex justify-between items-center bg-purple-50">
              <h3 className="font-bold text-purple-800 flex items-center gap-2 text-sm lg:text-base">
                <Users className="w-5 h-5" /> Subscribed Creators
              </h3>
              <button onClick={() => setShowSubModal(false)} className="text-gray-500 hover:text-gray-800 text-2xl font-bold leading-none">&times;</button>
            </div>

            <div className="max-h-[60vh] overflow-y-auto p-2">
              {loadingSubs ? (
                <p className="text-center py-10 text-gray-500 text-xs animate-pulse">Loading creators...</p>
              ) : subscribedCreators.length === 0 ? (
                <p className="text-center py-10 text-gray-500 text-xs">You haven't subscribed to anyone yet.</p>
              ) : (
                subscribedCreators.map(creator => (
                  <div 
                    key={creator.id}
                    onClick={() => handleNavigation(`/CreatorProfile/${creator.id}`)}
                    className="flex items-center gap-3 p-3 hover:bg-gray-50 cursor-pointer rounded-xl transition border-b border-gray-50 last:border-0"
                  >
                    <div className="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center overflow-hidden border border-blue-200 shrink-0">
                      {creator.avatarUrl ? (
                        <img src={creator.avatarUrl} alt="" className="w-full h-full object-cover" />
                      ) : (
                        <User className="w-5 h-5 text-blue-500" />
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="font-bold text-xs lg:text-sm text-gray-800 truncate">{creator.displayName}</p>
                      <p className="text-[10px] text-gray-500 truncate">
                        {creator.school} • Std {creator.standard}
                      </p>
                    </div>
                    <span className="text-blue-600 text-[10px] font-bold">Visit ›</span>
                  </div>
                ))
              )}
            </div>
            
            <div className="p-3 bg-gray-50 text-center">
              <button 
                onClick={() => setShowSubModal(false)}
                className="text-xs font-bold text-gray-400 hover:text-gray-600"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}